import {
  VENDOR_LOADING,
  GET_VENDOR,
  GET_VENDOR_SUCCESS,
  GET_VENDOR_FAIL,
  ADD_VENDOR_SUCCESS,
  ADD_VENDOR_FAIL,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_FAIL,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_FAIL,
  VENDOR_RESET,
  VENDOR_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  vendors: [],
  vendorAdded: {},
  error: {},
};

const Vendor = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_VENDOR_SUCCESS:
      switch (action.payload.actionType) {
        case GET_VENDOR:
          return {
            ...state,
            vendors: action.payload.data,
            isVendorCreated: false,
            isVendorSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_VENDOR_FAIL:
      switch (action.payload.actionType) {
        case GET_VENDOR_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isVendorCreated: false,
            isVendorSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_VENDOR: {
      return {
        ...state,
        isVendorCreated: false,
        loading: true,
      };
    }

    case VENDOR_LOADING: {
      return {
        ...state,
        isVendorCreated: false,
        loading: true,
      };
    }

    case ADD_VENDOR_SUCCESS:
      return {
        ...state,
        isVendorCreated: true,
        loading: false,
        vendors: [action.payload.data, ...state.vendors],
        vendorAdded: action.payload.data,
      };

    case ADD_VENDOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: state.vendors.filter(
          vendor => vendor.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_VENDOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: state.vendors.map(vendor =>
          vendor.id.toString() === action.payload.data.id.toString() ? { ...vendor, ...action.payload.data } : vendor
        ),
      };

    case UPDATE_VENDOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case VENDOR_RESET_CREATE:
      return {
        ...state,
        isVendorCreated: false,
      };

    case VENDOR_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Vendor;